"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VanityMappingSchema = exports.UpdateVanityMappingsResponseSchema = exports.UpdateVanityMappingsRequestSchema = exports.VanityMappingsResponseSchema = void 0;
var zod_1 = require("zod");
// Vanity Mappings API Types
/**
 * Schema for GET /v2/vanity-mappings response
 */
exports.VanityMappingsResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    vanityMappings: zod_1.z
        .record(zod_1.z.string(), zod_1.z.string())
        .describe('Object mapping vanity IDs to workflow IDs'),
});
/**
 * Schema for PUT /v2/vanity-mappings request body
 */
exports.UpdateVanityMappingsRequestSchema = zod_1.z.object({
    vanityMappings: zod_1.z
        .record(zod_1.z.string(), zod_1.z.string())
        .describe('Object mapping vanity IDs to workflow IDs'),
});
/**
 * Schema for PUT /v2/vanity-mappings response
 */
exports.UpdateVanityMappingsResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    message: zod_1.z.string(),
});
/**
 * Schema for individual vanity mapping entry
 */
exports.VanityMappingSchema = zod_1.z.object({
    id: zod_1.z.string().describe('The vanity ID'),
    workflowId: zod_1.z.string().describe('The workflow ID this vanity ID maps to'),
});
